/** 샵관리 — 매출등록. 회원권 결제는 회원권관리에서 자동 생성되고, 여기서는 단건 서비스·제품 판매 등을 직접 입력한다. */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import {
  loadTable, persistTable, createUid, num, today, customerOptions, PAY_METHOD_OPTIONS, SALE_TYPE_OPTIONS,
} from 'shop/shopStore';
import { selectField, dateRangeFields, inRange } from 'shop/shopPageHelpers';

const filter = (rows, v) =>
  rows.filter(
    (r) => r.mod !== 'D'
      && inRange(r.saleDate, v.fromDate, v.toDate)
      && (!v.saleType || r.saleType === v.saleType)
      && (!v.customerUid || r.customerUid === v.customerUid)
  );

const cfg = {
  gridId: 'sh-sale',
  title: '매출등록',
  uidKey: 'saleUid',
  searchDefaults: { fromDate: '', toDate: '', saleType: '', customerUid: '' },
  searchFields: ({ tc }) => [[
    ...dateRangeFields(),
    selectField('customerUid', '고객', customerOptions(tc), '200px'),
    selectField('saleType', '구분', SALE_TYPE_OPTIONS),
  ]],
  columns: ({ tc }) => [
    hiCol.edDateColumn({ header: '매출일자', field: 'saleDate', size: 120, required: true }),
    hiCol.edComboColumn({ header: '고객', field: 'customerUid', size: 170, options: [{ value: '', label: '(비회원)' }, ...customerOptions(tc)], align: 'left' }),
    hiCol.edComboColumn({ header: '구분', field: 'saleType', size: 90, required: true, options: SALE_TYPE_OPTIONS }),
    hiCol.edTextColumn({ header: '내용', field: 'itemNm', size: 220 }),
    hiCol.edNumberColumn({ header: '금액', field: 'grossAmount', size: 100, required: true }),
    hiCol.edNumberColumn({ header: '할인', field: 'discountAmount', size: 90 }),
    hiCol.roNumberColumn({ header: '실매출', field: 'netAmount', size: 100 }),
    hiCol.edComboColumn({ header: '결제수단', field: 'payMethod', size: 90, options: PAY_METHOD_OPTIONS }),
    hiCol.edCheckboxColumn({ header: '환불', field: 'refundYn', size: 64, title: '환불 건은 손익에서 제외' }),
    hiCol.edTextColumn({ header: '비고', field: 'remark', size: 180 }),
  ],
  load: (tc) => loadTable(tc, 'sale').map((s) => ({ ...s, mod: '' })),
  filter,
  emptyRow: () => ({
    saleUid: createUid('SALE'), saleDate: today(), customerUid: '', saleType: 'SERVICE', refUid: '', itemNm: '',
    grossAmount: 0, discountAmount: 0, netAmount: 0, payMethod: 'CARD', refundYn: 'N', remark: '',
  }),
  validate: (rows) => {
    const errors = [];
    for (const r of rows) {
      if (r.mod === 'D') {
        if (r.saleType === 'PASS' && r.refUid) errors.push('회원권 매출은 회원권관리에서 환불 처리하세요(삭제 불가).');
        continue;
      }
      if (!r.saleDate) errors.push('매출일자는 필수입니다.');
      if (num(r.discountAmount) > num(r.grossAmount)) errors.push('할인이 금액보다 클 수 없습니다.');
    }
    return errors;
  },
  save: (tc, rows, v) => {
    persistTable(tc, 'sale', 'saleUid', rows, (r) => filter([r], v).length > 0, (r) => ({
      ...r,
      grossAmount: num(r.grossAmount),
      discountAmount: num(r.discountAmount),
      netAmount: num(r.grossAmount) - num(r.discountAmount),
      refundYn: r.refundYn === 'Y' ? 'Y' : 'N',
    }));
  },
};
const SaleRegister = () => <ShopGridPage cfg={cfg} />;
export default SaleRegister;
